import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {authOperations} from '../../../reducks/auth';
import {commonOperations} from '../../../reducks/common';

import Template from '../../../components/templates/DrSideKoziCost/Detail/';

const mapStateToProps = (state) => ({
  currentTheme: state.style.theme,
  userInfo: state.auth.userInfo,
});

const mapDispatchToProps = {
  showMessage: commonOperations.doShowMessage,
  getUserInfo: authOperations.getUserInfoOperation,
};

/**
 * 改造工事費用算定 Page
 * 画面ID:1702
 *
 * @param {object} props
 * @return {JSX.Element} 改造工事費用算定画面
 */
const App = (props) => {
  return (
    <Template {...props} />
  );
};

const ContainerApp = connect(
    mapStateToProps,
    mapDispatchToProps,
)(App);

App.propTypes = {
  showMessage: PropTypes.func,
  getUserInfo: PropTypes.func,
  userInfo: PropTypes.object,
  history: PropTypes.object.isRequired,
};

export default ContainerApp;
